import React from 'react';
import { useTranslation } from 'react-i18next';
import { RoleService } from 'Services';
import PageHeader from 'Components/PageHeader';
import NewRuleTestsButton from '../NewRuleTestButton';

import styles from './RuleTestsHeader.css';

const RuleTestsHeader = () => {
    const { t } = useTranslation();

    return (
        <PageHeader>
            <PageHeader.Left data-testid='ruleTestsHeader' className={styles.headerText}>
                {t('Rule Tests')}
            </PageHeader.Left>
            <PageHeader.Right>{RoleService.hasRuleTestsEditAccess && <NewRuleTestsButton />}</PageHeader.Right>
        </PageHeader>
    );
};

export default RuleTestsHeader;
